export const countryConfig = {
  GB: { currency: "GBP", symbol: "£", lang: "en" },
  US: { currency: "USD", symbol: "$", lang: "en" },
  ES: { currency: "EUR", symbol: "€", lang: "es" },
  DEFAULT: { currency: "GBP", symbol: "£", lang: "en" },
};

export const conversionRates = {
  GBP: { GBP: 1, USD: 1.27, EUR: 1.1559 },
  USD: { GBP: 0.79, USD: 1, EUR: 0.91 },
  EUR: { GBP: 0.87, USD: 1.1, EUR: 1 },
};

export async function getLiveRate(from = "GBP", to = "EUR") {
  try {
    const res = await fetch(`https://open.er-api.com/v6/latest/${from}`);

    const data = await res.json();

    if (data?.rates?.[to]) {
      return data.rates[to];
    }
  } catch (err) {
    console.error("Live rate fetch failed", err);
  }

  console.log("Using fallback rate");
  return conversionRates[from]?.[to] || 1;
}

export function getConfigByCountryCode(countryCode = "GB") {
  const code = countryCode?.toUpperCase();
  return countryConfig[code] || countryConfig.DEFAULT;
}

export async function convertPrice(
  amount,
  fromCurrency = "GBP",
  toCurrency = "GBP",
) {
  if (fromCurrency === toCurrency) return amount;

  try {
    const liveRate = await getLiveRate(fromCurrency, toCurrency);
    return Number((amount * liveRate).toFixed(2));
  } catch (err) {
    console.error("Live conversion failed, using fallback rate");

    const fallbackRate = conversionRates[fromCurrency]?.[toCurrency] || 1;
    return Number((amount * fallbackRate).toFixed(2));
  }
}

export function formatCurrency(amount, countryCode = "GB") {
  const { symbol, lang } = getConfigByCountryCode(countryCode);

  const num = Number(amount) || 0;

  const formattedNumber = new Intl.NumberFormat(lang, {
    minimumFractionDigits: num % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  })
    .format(num)
    .replace(",", ".");

  return `${symbol}${formattedNumber}`;
}
